import Vue from 'vue'

import store from '../store'

const VueInstance = new Vue();

const get = (path, data, cb, errorCb) => {
  VueInstance.$http.get(path, {params: data})
    .then((response) => {
      cb(response);
  }).catch(error => {
    const response = error.response;

    if (response && response.status) {
      if (response.status === 401 || response.status === 403) {
        store.dispatch('authRefreshToken', {
          cb: () => {
            this.get(path, data, cb, errorCb);
          }
        })
        return;
      }
    }

    if (!errorCb && error.response) {
      eventHub.$emit('ajax-error', error.response);
      return;
    }

    if (errorCb) {
      errorCb(error);
    }
  });
}

const remove = (path, cb, errorCb) => {
  VueInstance.$http.delete(path)
    .then((response) => {
      cb(response);
  }).catch(error => {
    const response = error.response;

    if (response && response.status) {
      if (response.status === 401 || response.status === 403) {
        store.dispatch('authRefreshToken', {
          cb: () => {
            this.remove(path, cb, errorCb);
          }
        })
        return;
      }
    }

    if (!errorCb && error.response) {
      eventHub.$emit('ajax-error', error.response);
      return;
    }

    if (errorCb) {
      errorCb(error);
    }
  });
}

const post = (path, data, cb, errorCb) => {
  VueInstance.$http.post(path, data)
    .then((response) => {
      cb(response);
    }).catch(error => {
    const response = error.response;

    if (response && response.status) {
      if (response.status === 401 || response.status === 403) {
        store.dispatch('authRefreshToken', {
          cb: () => {
            this.post(path, data, cb, errorCb);
          }
        })
        return;
      }
    }

    if (!errorCb && error.response) {
      eventHub.$emit('ajax-error', error.response);
      return;
    }

    if (errorCb) {
      errorCb(error);
    }
  });
}

const put = (path, data, cb, errorCb) => {
  VueInstance.$http.put(path, data)
    .then((response) => {
      cb(response);
  }).catch(error => {
    const response = error.response;

    if (response && response.status) {
      if (response.status === 401 || response.status === 403) {
        store.dispatch('authRefreshToken', {
          cb: () => {
            this.put(path, data, cb, errorCb);
          }
        })
        return;
      }
    }

    if (!errorCb && error.response) {
      eventHub.$emit('ajax-error', error.response);
      return;
    }

    if (errorCb) {
      errorCb(error);
    }
  });
}

export {
  get,
  remove,
  post,
  put
}


// WEBPACK FOOTER //
// ./src/services/BaseService.js